'use strict';

var util = require('lyonscg/util/utils.js');
var formValidation = require('base/components/formValidation');

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('.modal-email-signup').length !== 0) {
        $('.modal-email-signup').remove();
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade modal-email-signup" role="dialog" tabindex="-1" role="dialog" aria-hidden="true">'
        + '<div class="modal-dialog" style="margin: auto !important; position: absolute; left: 50%; top: 50%; '
        + 'transform: translate(-50%, -50%); max-width: 470px;">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal"></button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.email-modal');

    return { body: body };
}

/**
 * Replaces the content in the modal window for email updates and offers modal.
 * @param {string} modalUrl - url to be used to retrieve a email optin model
 */
function fillModalElement(modalUrl) {
    $('.modal-content').spinner().start();

    $.ajax({
        url: modalUrl,
        method: 'GET',
        dataType: 'html',
        success: function (html) {
            var parsedHtml = parseHtml(html);

            parsedHtml.body.removeClass('email-modal');
            $('.modal-email-signup .modal-body').empty();
            $('.modal-email-signup .modal-body').html(parsedHtml.body);
            $('.modal-email-signup .modal-footer').html(parsedHtml.footer);
            $('.modal-email-signup').modal('show');
            $('#email-signup-form-email').val($('#newsletterEmailAddress').val());
            $('#newsletterEmailAddress').val('');
            $('#email-signup-form-firstname').focus();
            $('.modal-content').spinner().stop();
        },
        error: function () {
            $('.modal-content').spinner().stop();
        }
    });
}

module.exports = function () {
    $('#newsletterSignup').on('submit', function (e) {
        e.preventDefault();

        var modalUrl = $(this).attr('action');
        getModalHtmlElement();
        fillModalElement(modalUrl);
    });

    $(document).on('change blur', '#email-signup-form-email, #email-signup-form-emailconfirm', function () {
        var $confirmInput = $('#email-signup-form-emailconfirm');
        if ($('#email-signup-form-email').val() !== $('#email-signup-form-emailconfirm').val()) {
            $('.newsletterSubscribeButton').attr('disabled', 'disabled');

            // show error
            $confirmInput.addClass('is-invalid');
            $confirmInput.closest('.form-group').addClass('is-invalid');
            $confirmInput.parents('.form-group').find('.invalid-feedback')
            .text($confirmInput.data('pattern-mismatch'));
        } else {
            // remove error
            $confirmInput.removeClass('is-invalid');
            $confirmInput.closest('.form-group').removeClass('is-invalid');
            $confirmInput.parents('.form-group').find('.invalid-feedback')
            .text('');
        }
    });

    $(document).on('change', 'form.newsletterSubscribe input', function () {
        var emptyInput = false;
        $('form.newsletterSubscribe input:not("#email-signup-form-firstname"):not("#email-signup-form-lastname")').each(function () {
            if ($(this).val() === '') {
                emptyInput = true;
            }
        });
        if (emptyInput) {
            $('.newsletterSubscribeButton').attr('disabled', 'disabled');
        } else if ($('form.newsletterSubscribe #email-signup-form-termsconditions').is(':checked')) {
            if ($('#email-signup-form-email').val() === $('#email-signup-form-emailconfirm').val()) {
                $('.newsletterSubscribeButton').removeAttr('disabled');
            }
        } else {
            $('.newsletterSubscribeButton').attr('disabled', 'disabled');
        }
    });

    $(document).on('submit', 'form.newsletterSubscribe', function (e) {
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        $('.modal-email-signup').spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                $('.modal-email-signup').spinner().stop();
                if (!data.success) {
                    if (data.errorMessage) {
                        $('form.newsletterSubscribe').html('<div class="col-sm-12 body-l email-description">' + data.errorMessage + '</div>');
                    } else {
                        formValidation(form, data);
                    }
                } else {
                    var successHTML = '<div id="welcome-message-section" class="welcome-message-section" style="width: 100%;"><h1 style="text-align: left; ';
                    successHTML += 'font-size: 2rem; color: #403f3a; padding-left: 12px;">' + data.successWelcome + '</h1></div><br>';
                    successHTML += '<div class="col-sm-12 body-l email-description" style="line-height: 2;">' + data.successMsg + '</div>';

                    $('form.newsletterSubscribe').html(successHTML);
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }

                $('.modal-email-signup').spinner().stop();
            }
        });
        return false;
    });

    $('.footer-item h1').on('click', function () {
        if (util.mediaBreakpointDown('md')) {
            $(this).parents('.footer-item').toggleClass('active');
        }
    });
};
